"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getXMLValidity = getXMLValidity;
var _xmlFormatter = _interopRequireDefault(require("xml-formatter"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function getXMLValidity(_ref) {
  var input = _ref.input,
    selectedSpaces = _ref.selectedSpaces,
    encodingRadio = _ref.encodingRadio;
  try {
    (0, _xmlFormatter["default"])(input, {
      indentation: "  ",
      collapseContent: true,
      lineSeparator: "\n"
    });
    return "XML is valid!";
  } catch (e) {
    throw e;
  }
}